import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function DikkatTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['dikkat-testi']} />;
}
